const { default: tippy } = require("tippy.js");

const element = document.querySelector('[js-footer-phone-tippy]');
if (element) {
    const instance = new tippy(element, {
        content: element.getAttribute("data-html"),
        allowHTML: true,
        trigger: 'mouseenter',
        interactive: true,
        theme: 'footer-phone',
         onShow(instance) {
            instance.setProps({
            placement: window.innerWidth < 1024 ? 'left' : 'top',
            });
        },
    });

}